module.exports = __webpack_public_path__ + "static/media/screen2.6b9e2819.png";